import type { AppConfig } from './types';

function getEnvVar(key: string, fallback?: string): string {
  const value = import.meta.env[key] ?? fallback;
  if (value === undefined) {
    throw new Error(`Missing required environment variable: ${key}`);
  }
  return value;
}

export function getConfig(): AppConfig {
  const appEnv = getEnvVar('VITE_APP_ENV', 'dev') as 'dev' | 'prod';
  const writebackApiUrl = getEnvVar('VITE_WRITEBACK_API_URL', '');

  if (!writebackApiUrl) {
    throw new Error('Missing required environment variable: VITE_WRITEBACK_API_URL');
  }

  return {
    appEnv,
    writebackApiUrl,
  };
}
